<template>
  <nav
    class="navbar"
    :class="[
      { 'navbar--space': hasMainMenuOpen },
      { 'navbar--border': navbarActions },
    ]"
  >
    <Actions v-if="navbarActions" />
    <NavigationDrawer v-if="menuVisible" />
    <Brand v-if="menuVisible" />
  </nav>
</template>

<script>
import { mapState } from 'vuex'
import Actions from 'components/Navbar/Actions'
import NavigationDrawer from 'components/Navbar/NavigationDrawer'
import Brand from 'components/Navbar/Brand'

export default {
  name: 'Navbar',
  components: {
    Actions,
    NavigationDrawer,
    Brand
  },
  computed: {
    ...mapState({
      hasMainMenuOpen: ({ mainMenu }) => mainMenu.isOpen
    }),

    menuVisible () {
      return this.$route.meta.menu
    },

    navbarActions () {
      return this.$route.meta.navbarActions
    }
  }
}
</script>

<style lang="scss">
.navbar {
  border-bottom: 1px solid $gray-2;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 3;

  @media (min-width: 961px) {
    border-bottom: none;
  }

  &.navbar--border {

    &:before {

      @media (min-width: 961px) {
        background-color: $gray-2;
        content: '';
        height: 1px;
        left: 184px;
        position: fixed;
        right: 0;
        top: $toolbar-height;
        z-index: 1;
      }
    }
  }

  &.navbar--space {

    &:before {

      @media (min-width: 961px) {
        left: $menu-width;
      }
    }
  }

  .v-toolbar__items {

    .v-btn:not(.v-btn--round).v-size--default,
    .v-btn:not(.v-btn--round).v-size--large {
      min-width: auto;
    }
  }
}
</style>
